import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import AbortButton from '@/components/buttons/AbortButton'
import SuccessButton from '@/components/buttons/SuccessButton'

interface IPopupDialog {
  isOpen: boolean
  title: string | React.ReactNode
  content: string | React.ReactNode
  disabled?: boolean
  isLoading: boolean
  disableMaxWidth?: boolean
  confirmButton?: React.ReactNode
  fullScreen?: boolean
  onClose: () => void
  onConfirm?: () => void
}

const PopupDialog: React.FC<IPopupDialog> = ({
  isOpen,
  title,
  content,
  disabled,
  isLoading,
  disableMaxWidth,
  confirmButton,
  fullScreen,
  onClose,
  onConfirm,
}) => {
  let cButton: React.ReactNode = (
    <SuccessButton
      isLoading={isLoading}
      onClick={onConfirm}
      disabled={disabled}
    />
  )
  if (confirmButton) {
    cButton = confirmButton
  }
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={disableMaxWidth ? false : 'sm'}
      fullScreen={fullScreen}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <AbortButton onClick={onClose} disabled={isLoading} />
        {(onConfirm || confirmButton) && cButton}
      </DialogActions>
    </Dialog>
  )
}

export default PopupDialog
